import React, { useCallback } from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import Button from 'theme/buttons/btn-back';
import ArrowLeft from 'theme/icons/arrow-left';
import Text from 'theme/text';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  & > p {
    white-space: nowrap;
  }
`;

function BackButton({ label, href }) {
  const { push } = useRouter();

  const handleBackBtn = useCallback(() => {
    push(href);
  }, [push, href]);

  return (
    <Wrapper>
      <div>
        <Button
          type="button"
          style={{
            width: '38px',
            height: '38px',
            bg: 'primary_50',
            mr: 's',
            ml: 'l',
          }}
          onClick={handleBackBtn}
        >
          <ArrowLeft />
        </Button>
      </div>
      <Text fontSize="h2" lineHeight="h2" fontWeight="bold" color="grey_600">
        {label}
      </Text>
    </Wrapper>
  );
}

export default BackButton;
